<template>
<div>
	<el-card class="box-card">
		<div slot="header" class="flex-be">
			<div class="search_condition">
				<el-date-picker class="m-r-10" size="small" v-model="dateTime" type="datetimerange"
					value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" @change="changeTime">
				</el-date-picker>

				<el-select size="small" v-model="status" placeholder="请选择" class="search_condition_item"
					@change="getDataFn">
					<el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="content_table">
			<tableTotal v-if="configTable.tableData.length > 0" :index-show="configTable.indexShow"
				:config-data="configTable.configData" :table-data="configTable.tableData" :loading="configTable.loading"
				@handleClick="handleClick" @selectChange="handleSelectionChangeFn"
				@handleSelectionChange="handleSelectionChangeFn">
				<!-- <template #goodInfo="{ data }">
					<div>区域范围：{{ data.goodInfo ? data.goodInfo.area || '-' : '--' }}</div>
					<div>采集时间：{{ data.goodInfo ? data.goodInfo.productDate || '-' : '--' }}</div>
					<div>产品级别：{{ data.goodInfo ? data.goodInfo.productLevel || '-' : '--' }}</div>
					<div>传感器：{{ data.goodInfo ? data.goodInfo.sensor || '-' : '--' }}</div>
					<div>规格：<span v-html="$options.filters.filter(data.goodsSpecifica)"></span></div>
				</template>
				<template #productPrice="{ data }">
					<span class="price_num_comm">
						{{ data.goodsPriceType === 1 ? '￥' + data.goodPrice :
							(data.goodsPriceType === 2 ? '价格面议' : '免费') }}
					</span>
				</template> -->
				<template #productPrice="{ data }">
					<div v-html='data.content' style="text-align:center;margin:15px;background:#ccc;padding:15px;min-height:50px"></div>
				</template> 
			</tableTotal>
			<el-empty v-if="configTable.tableData.length <= 0" description="暂无数据"></el-empty>
		</div>
		<!-- <shopDetail style="width: 100%"></shopDetail> -->
		<!-- <div class="flex-be m-t-20">
			<el-button size="small" type="primary" @click="batchDeletionFn">批量删除</el-button>
			<el-pagination @current-change="getDataFn" @size-change="handleSizeChange"
				:current-page.sync="configTable.current" layout="total, sizes, prev, pager, next, jumper" background
				:page-sizes="[10, 15, 20]" :page-size="configTable.pageSize" :total="configTable.total"></el-pagination>
		</div> -->
	</el-card>
</div>
</template>

<script>
// import AppHeader_Navs from "./AppHeader_Navs.vue";
// const shopDetail = () => import('@/views/RemoteSensingMall/shopDetail.vue');


import tableTotal from "@/components/TableTotal/TableTotal";

export default {
	name: "favoritesList",
	// import引入的组件需要注入到对象中才能使用
	components: {
		tableTotal,
	},
	filters: {
		filter(value) {
			if (!value) {
				return '-'
			}
			if (!value.goodsSpec) {
				return '-'
			}
			if (value.goodsSpec[0] === '{') {
				let str = value.goodsSpec.slice(1, value.goodsSpec.length - 1)
				return str.replace(/,/g, ',').replace(/"/g, '').replace(/:/g, ' : ')
			}
		}
	},
	data() {
		// 这里存放数据
		return {
			dateTime: '',
			status: 0,
			statusList: [
				{ value: 0, label: '全部状态', },
				{ value: 1, label: '上架', },
				{ value: 2, label: '下架', },
			],
			// 配置表格
			configTable: {
				loading: false,
				indexShow: false,
				configData: [
					// {
					// 	type: 'selection'
					// },
					// {
					// 	value: 'image',
					// 	label: '新闻图片',
					// 	width: 150,
					// 	align: 'left',
					// 	type: 'img'
					// },
					{
						align: 'center',
						expand:'expand',
						type: "custom",
						customName: "productPrice"
					},
					{
						value: 'title',
						label: '新闻标题',
						align: 'center'
					},
					{
						value: 'source',
						label: '来源',
						width: 220,
						align: 'center',
		
					},
					{
						value: 'author',
						label: '作者',
						width: 220,
						align: 'center',
		
					},
					// {
					// 	value: 'shelfStatus',
					// 	label: '状态',
					// 	align: 'center',
					// 	objList: { //
					// 		1: '上架',
					// 		2: '下架',
					// 	}
					// },
				
					{
						value: 'updateTime',
						label: '更新时间',
						align: 'center',
						type: 'timeDate'
					},
					{
						label: '操作', width: '120', fixed: 'right', type: 'handleList', buttonList: [
							// { label: '查看', event: 'seeData', show: true, showText: true },
							// {
							// 	label: '删除', event: 'delete', show: true, showText: true,
							// 	text: '确定删除该收藏?',
							// },
						]
					}
				],
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10
			},
			tableSelect: []
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.info();
	},
	// 方法集合
	methods: {
		info() {
			// 获取数据
			this.getDataFn();
		},
		changeTime() {
			this.configTable.current = 1;
			this.getDataFn();
		},
		async getDataFn() {
			// let params = {
			// 	startTime: this.dateTime ? this.dateTime[0] : '',
			// 	endTime: this.dateTime ? this.dateTime[1] : '',
			// 	pageNum: this.configTable.current,
			// 	pageSize: this.configTable.pageSize,
			// };
			try {
				this.configTable.loading = true;
				let res = await this.$http.get(this.$const.common.newsListURL);
				if (res ) {
					console.log(res);
					this.configTable.tableData = res.rows;
					this.configTable.total =res.total;
					this.configTable.loading = false;
				}
			} catch (e) {
				this.configTable.loading = false;
				// console.log(e);
			}
		},
		async handleClick(event, data, text) {
			switch (event) {
				case 'seeData':
					this.$router.push({ name: "shopDetail", params: { id: data.goodId}});
					break;
				case 'delete':
					this.$confirm(text, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
						.then(async () => {
							let p = {
								collectId: data.id
							};
							await this.collectDeleteFn(p);
						});
					break;
			}
		},
		async collectDeleteFn(data) {
			try {
				let res = await this.$http.delete(this.$const.personalCenter.collectDelete, data);
				if (res && res.code === 200) {
					// console.log(res);
					this.$message.success(this.$PubText.successCom);
					this.getDataFn();
				}
			} catch (e) {
				// console.log(e);
			}
		},
		handleSizeChange(val) {
			this.configTable.pageSize = val;
			this.getDataFn();
		},
		// 表格多选 全选
		handleSelectionChangeFn(data) {
			this.tableSelect = data;
		},
		batchDeletionFn() {
			if (this.tableSelect.length <= 0) {
				this.$message.warning(this.$PubText.multipleTip);
				return;
			}
			const ids = this.tableSelect.map((item) => {
				return item.id
			});
			let p = {
				collectId: ids.toString()
			};
			this.collectDeleteFn(p);
		},
	},
}
</script>

<style lang="scss" scoped>
.search_condition_item {
	width: 140px;
}

.pagination_box {
	text-align: right;
}
</style>
